import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LogoUrl from './../../assets/img/logo.svg';
import InfiniteTextScroll from "./component.infinite_text_scroll";
import SmartLink from "../../lib/includes/components/component.smartlink";

const Footer = (props) => {
    if (!props.general) {
      return null;
    }

    return <footer>

        <div className="site-footer">


            <div className="container">

                <div className="row">
                    <div className="col-12 col-lg-2 mb-3">
                        <p>Kontakt</p>
                    </div>
                    <div className="col-12 col-lg-4 mb-3">


                        {props.general.footer.adress &&
                            <p dangerouslySetInnerHTML={{ __html: props.general.footer.adress }} />
                        }

                        {props.general.footer.telefon &&
                            <span>Tel. {props.general.footer.telefon}<br/></span>
                        }
                        {props.general.footer.mail &&
                            <a href={"mailto:" + props.general.footer.mail}>{props.general.footer.mail}</a>
                        }


                    </div>
                    <div className="col-12 col-lg-6 mb-3">

                        <p>
                        {props.general.footer.links?.map((item, i) => {

                            return <div><SmartLink url={item.link.url} target={item.link.target}>{item.link.title}</SmartLink><br/></div>

                        })}
                        </p>


                    </div>
                </div>


            </div>




            <div className="container disclaimer-container">


                <div className="row">
                    <div className="col-12 col-lg-2">
                        <p>Skill © 2025</p>
                    </div>
                </div>


            </div>
        </div>
        <div><InfiniteTextScroll/></div>
    </footer>
};

export default connect(
  state => {
    return {
      general: state.generalState.general
    }
  },
)(Footer);
